import { Injectable } from '@angular/core';

/**
 * Service that generates unique instance IDs for components
 * Each call to generateId() returns a new unique identifier
 */
@Injectable({
  providedIn: 'root',
})
export class InstanceIdService {
  private static idCounter = 0;

  /**
   * Generates a unique instance ID
   * @returns A unique string identifier
   */
  generateId(): string {
    return `instance_${++InstanceIdService.idCounter}_${crypto.randomUUID()}`;
  }
}
